import * as React from "react";
import { forwardRef } from "react";
const SvgBackgroundLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 201 184", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#34D399", d: "m200.334 101-98 99v-99z", opacity: 0.1 }), /* @__PURE__ */ React.createElement("path", { fill: "#34D399", d: "M102.334 0v101h-102V0z", opacity: 0.2 }));
const ForwardRef = forwardRef(SvgBackgroundLeft);
export default ForwardRef;
